import { gql } from "@apollo/client";

export const TUS_CHANGE_PICTURE = gql`
  mutation TusChangePicture($upload: String) {
    tusChangePicture(upload: $upload)
  }
`;
